import Vue from 'vue'

export function dingtalkH5List() {
  return Vue.axios({
    url: '/api/dingtalk/appServer',
    method: 'get'
  })
}

export function saveDingTalkH5(data) {
  return Vue.axios({
    url:'/api/dingtalk/saveAppServer',
    method: 'post',
    data: {...data}
  })
}

export function scanLoginList() {
  return Vue.axios({
    url: '/api/dingtalk/appScanLogin',
    method: 'get'
  })
}

export function saveDingTalkScanLogin(data) {
  return Vue.axios({
    url:'/api/dingtalk/saveAppScanLogin',
    method: 'post',
    data: {...data}
  })
}
export function getDept() {
  return Vue.axios({
    url:'/api/dingtalk/deptList',
    method:'get'
  })
}

export function getDingUser(data) {
  return Vue.axios({
    url:'/api/dingtalk/userList',
    method:'get',
    params: {...data}
  })
}

export function updateUser(id) {
  let data={id:id}
  return Vue.axios({
    url:'/api/dingtalk/userUpdate',
    method: 'post',
    data: {...data}
  })
}

// 获取白名单数据
export function getWhiteList(data) {
  return Vue.axios({
    url: '/api/sys_config/get_info',
    method: 'post',
    data: {...data}

  })
}

// 修改白名单
export function saveWhite(data) {
  return Vue.axios({
    url: '/api/sys_config/save_info',
    method: 'post',
    data: {...data}
  })
}
